import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Plus, Save, Trash2 } from 'lucide-react';
import { PCT_REFERIDO, PUNTOS_REFERIDO, bodasApi, mensajeError } from '../bodasUtils';
import { CampoTexto, Panel } from './comunes';

const VACIA = { marca_nombre: '', whatsapp: '', correo_contacto: '', politica_url: '', redes: [], referido_aplica: '', referido_condiciones: '', referido_vigencia: '' };

const RedesEditor = ({ redes, onChange }) => {
  const cambiar = (i, campo, v) => onChange(redes.map((r, j) => (j === i ? { ...r, [campo]: v } : r)));
  return (
    <div className="space-y-3">
      {redes.map((r, i) => (
        <div key={i} className="grid gap-2 sm:grid-cols-[1fr_1fr_2fr_auto]" data-testid={`ajustes-red-${i}`}>
          <CampoTexto label="Nombre" value={r.nombre} onChange={v => cambiar(i, 'nombre', v)} placeholder="Tienda" />
          <CampoTexto label="Usuario" value={r.usuario} onChange={v => cambiar(i, 'usuario', v)} placeholder="@juanpablomurillo" />
          <CampoTexto label="Enlace" value={r.url} onChange={v => cambiar(i, 'url', v)} placeholder="https://instagram.com/…" />
          <button type="button" onClick={() => onChange(redes.filter((_, j) => j !== i))} className="self-end rounded-lg p-2.5 text-red-700 hover:bg-red-50" aria-label="Quitar red"><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      {redes.length < 4 && (
        <button type="button" onClick={() => onChange([...redes, { nombre: '', usuario: '', url: '' }])} className="inline-flex items-center gap-1.5 text-sm font-medium text-emerald-700 hover:underline" data-testid="ajustes-agregar-red">
          <Plus className="h-4 w-4" />Agregar red social
        </button>
      )}
    </div>
  );
};

export default function AjustesBodas() {
  const [cfg, setCfg] = useState(VACIA);
  const [guardando, setGuardando] = useState(false);
  const set = (campo) => (v) => setCfg(prev => ({ ...prev, [campo]: v }));

  useEffect(() => { bodasApi.config().then(c => setCfg({ ...VACIA, ...c })).catch(e => toast.error(mensajeError(e))); }, []);

  const guardar = async () => {
    setGuardando(true);
    try { setCfg({ ...VACIA, ...(await bodasApi.guardarConfig(cfg)) }); toast.success('Ajustes guardados'); }
    catch (e) { toast.error(mensajeError(e, 'No se pudieron guardar los ajustes')); }
    finally { setGuardando(false); }
  };

  return (
    <div className="space-y-6" data-testid="ajustes-bodas">
      <Panel className="space-y-4 p-5">
        <h2 className="font-semibold text-slate-800">Contacto que ven los invitados</h2>
        <div className="grid gap-4 sm:grid-cols-2">
          <CampoTexto label="Nombre de la marca" value={cfg.marca_nombre} onChange={set('marca_nombre')} testId="ajustes-marca" />
          <CampoTexto label="WhatsApp de la tienda" value={cfg.whatsapp} onChange={set('whatsapp')} ayuda="Con indicativo y solo números, ej.: 573001234567" testId="ajustes-whatsapp" />
          <CampoTexto label="Correo para datos personales" value={cfg.correo_contacto} onChange={set('correo_contacto')} testId="ajustes-correo" />
          <CampoTexto label="Enlace a la Política de Tratamiento de Datos" value={cfg.politica_url} onChange={set('politica_url')} testId="ajustes-politica" />
        </div>
        <RedesEditor redes={cfg.redes || []} onChange={set('redes')} />
      </Panel>
      <Panel className="space-y-4 p-5">
        <h2 className="font-semibold text-slate-800">Enlaces de referidos ({PCT_REFERIDO}% fijo)</h2>
        <p className="text-sm text-slate-500">El {PCT_REFERIDO}% y los {PUNTOS_REFERIDO} Puntos JPM son fijos. Aquí solo ajustas el texto que acompaña el beneficio.</p>
        <CampoTexto label="En qué aplica" value={cfg.referido_aplica} onChange={set('referido_aplica')} placeholder="En tu primer traje a la medida" testId="ajustes-referido-aplica" />
        <CampoTexto label="Condiciones" value={cfg.referido_condiciones} onChange={set('referido_condiciones')} multiline testId="ajustes-referido-condiciones" />
        <CampoTexto label="Vigencia" value={cfg.referido_vigencia} onChange={set('referido_vigencia')} placeholder="Hasta el 31 de diciembre" testId="ajustes-referido-vigencia" />
      </Panel>
      <button type="button" onClick={guardar} disabled={guardando} className="inline-flex items-center gap-2 rounded-lg bg-slate-800 px-5 py-2.5 font-medium text-white hover:bg-slate-700 disabled:opacity-60" data-testid="ajustes-guardar">
        <Save className="h-4 w-4" />{guardando ? 'Guardando…' : 'Guardar ajustes'}
      </button>
    </div>
  );
}
